import React from 'react';
import PropTypes from 'prop-types';
import { ModalHeader } from 'reactstrap';
import { useIntl } from 'react-intl';

const ImporterModalHeader = ({ handleClose, importer }) => {
  const intl = useIntl();

  return (
    <ModalHeader toggle={handleClose} className="modal-header-center">
      {intl.formatMessage({
        defaultMessage: 'Import from {name}',
      }, { name: importer.name })}
    </ModalHeader>
  );
};

ImporterModalHeader.propTypes = {
  importer: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ImporterModalHeader;
